import FanTagInput from './FanTagInput';

export default FanTagInput;
